import { FC } from 'react'
import { DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { ContainedButton, OutlinedButton } from '../styled'
import { useDispatch } from 'react-redux'
import { decrementDocumentationStep, incrementDocumentationStep } from '../../../store/documentSlice'
import './style.scss'

interface ShowFunctionalitiesProps {
  coreFunctionalities: any
}

const ShowFunctionalities: FC<ShowFunctionalitiesProps> = ({ coreFunctionalities }) => {
  const dispatch = useDispatch()
  return (
    <div className='functionality-container'>
      <DialogTitle className='functionality-head'>Here is your core functionalities</DialogTitle>
      <DialogContent>
        {coreFunctionalities?.map((functionality: any, index: number) => {
          return <div className='each-functionality-container'>
            <div className='functionality-key-container'>{index + 1}. {functionality?.name}</div>
            <div className='functionality-value-container'>{functionality.description}</div>
          </div>
        })}
      </DialogContent>
      <DialogActions>
        <div className='dialog-action-container'>
          <OutlinedButton onClick={() => dispatch(decrementDocumentationStep())}>
            Back
          </OutlinedButton>
          <ContainedButton
            onClick={() => dispatch(incrementDocumentationStep())}
          >Proceed
          </ContainedButton>
        </div>
      </DialogActions>
    </div>
  )
}

export default ShowFunctionalities